import React from 'react';
import { IAssistantMessage } from '../../../types';
import { ChatMessage } from '../../message-box';

interface UserMessageBubbleProps {
    message: IAssistantMessage;
}

export const UserMessageBubble: React.FC<UserMessageBubbleProps> = ({ message }) => {
    return (
       <ChatMessage message={message}/>
    );
};
